
import Vue from 'vue';
import { getQueryStringParams } from '@/utils';

async function checkSingleLoginToken() {
  const singleLoginToken = getQueryStringParams(window.location.href.split('?')[1]).t;
  if (!singleLoginToken) {
    return null;
  }
  try {
    return (await Vue.$http.post('users/token/', null, {
      headers: {
        Authorization: `Single ${singleLoginToken}`,
      },
    })).data;
  } catch (e) {
    // invalid Token
    return null;
  }
}

async function checkRefreshToken() {
  const refreshToken = localStorage.getItem('REFRESH_TOKEN');
  if (!refreshToken) {
    return null;
  }
  try {
    return (await Vue.$http.post('users/token/', null, {
      headers: {
        Authorization: `Refresh ${refreshToken}`,
      },
    })).data;
  } catch (e) {
    // invalid Token
    return null;
  }
}

async function initializeUser({ token, refresh_token: refreshToken }) {
  localStorage.setItem('REFRESH_TOKEN', refreshToken);
  Vue.$http.defaults.headers.common = {
    Authorization: `JWT ${token}`,
  };
  return (await Vue.$http.get('users/self/')).data;
}


export async function getInitialState() {
  let tokens = await checkSingleLoginToken();

  if (!tokens) {
    tokens = await checkRefreshToken();
  }

  if (!tokens) {
    return undefined;
  }

  return {
    user: await initializeUser(tokens),
  };
}

export default (initialState = {
  user: null,
}) => ({
  namespaced: true,
  state: initialState,
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setProfile(state, profile) {
      state.user.profile = profile;
    },
  },
  actions: {
    async initializeUser({ commit }, tokens) {
      commit('setUser', await initializeUser(tokens));
    },
    async logout({ commit }) {
      commit('setUser', null);
      const refreshToken = localStorage.getItem('REFRESH_TOKEN');
      localStorage.removeItem('REFRESH_TOKEN');
      try {
        await Vue.$http.delete(`/users/refresh_tokens/${refreshToken}/`);
      } catch (e) {
        // Probably already deleted
      }
      Vue.$http.defaults.headers.common = {
        Authorization: undefined,
      };
    },
    async updateProfile({ commit }, profile) {
      const updatedProfile = (await Vue.$http.patch(`/profiles/${profile.id}/`, profile)).data;
      commit('setProfile', updatedProfile);
    },
    emailVerified({ state, commit }) {
      commit('setUser', { ...state.user, email_verified: true });
    },
  },
  getters: {
    isLoggedIn: state => !!state.user,
    isLoggedInEmployer: state => state.user && ['owner', 'charterer'].indexOf(state.user.type) !== -1,
    isLoggedInEmployee: state => state.user && state.user.type !== 'owner',
    isLoggedInOfTypes: state => types => state.user && types.indexOf(state.user.type) !== -1,
    canSeePrivateContent: state => state.user && state.user.profile.profile_saved,
  },
});
